import { LoadingService } from '../services';
import { SharedModule } from '../shared.module';

export function IsLoading(loadingTag: string): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const loadingServiceInstance: LoadingService = SharedModule?.injector.get(LoadingService);

        Object.defineProperty(target, propertyKey, {
            value: loadingServiceInstance?.getIsLoading(loadingTag),
        });
    };
}
